<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";

import type { CfgAll } from "@/types/config";
import { LoginState } from "@/types/enums";

import { authStorage } from "@/stores/auth";
import { configStore } from "@/stores/config";
import { addErrorBottom } from "@/stores/messages";

import { useComponentErrorCapture } from "@/mixins/error";

useComponentErrorCapture();

const auth = authStorage();
const config = configStore();
const cfg = ref<CfgAll | null>(null);
const time_format_24h = ref(true);
const time_zone = ref("UTC");
config.$subscribe((mutation, state) => {
  time_format_24h.value = state?.config?.localization?.time_format_24h || true;
  time_zone.value = state?.config?.localization?.time_zone || "UTC";
});

const currentTime = ref("");

auth.$subscribe(async (mutation, state) => {
  if (state.authenticated == LoginState.AUTHORISED && cfg.value == null) {
    await getConfigData();
  }
})

function getTime() {
  if (cfg.value == null) {
    return;
  }

  currentTime.value = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: !time_format_24h.value,
    timeZone: time_zone.value,
  });
}

async function getConfigData() {
  try {
    cfg.value = await config.getAll();
    time_format_24h.value = cfg?.value?.localization?.time_format_24h || true;
    time_zone.value = cfg?.value?.localization?.time_zone || "UTC";
  } catch (e: any) {
    addErrorBottom(e);
  }
}

let timer: number;
onMounted(async () => {
  if (auth.authenticated == LoginState.AUTHORISED) {
    await getConfigData();
  }

  timer = <any>setInterval(getTime, 1000);
});

onUnmounted(() => {
  clearInterval(timer);
});

</script>
<template>
  <div v-if="currentTime != null" class="time">{{ currentTime }}</div>
</template>
